import request from '@/plugins/axios'

//注册外部用户
export function userReg(params, data) {
    return request({
        url: '/open/userReg',
        method: 'post',
        params,
        data
    })
}

//查询单个征稿活动
export function getPictureActivity(params) {
    return request({
        url: '/open/getPictureActivity/' + params,
        method: 'get'
    })
}

//查询单个征稿活动
export function listPictureActivityArticle(params) {
    return request({
        url: '/open/listPictureActivityArticle',
        method: 'get',
        params,
    })
}

//查询多个图片
export function getPictures(params) {
    return request({
        url: '/open/getPictures',
        method: 'get',
        params,
    })
}

//外部用户登录
export function userLogin(params) {
    return request({
        url: '/open/userLogin',
        method: 'post',
        params
    })
}

//获取文本与协议配置
export function getAppSecurityConfig() {
    return request({
        url: '/open/getAppSecurityConfig',
        method: 'get'
    })
}

//获取安全配置
export function getAppTextConfig() {
    return request({
        url: '/open/getAppTextConfig',
        method: 'get'
    })
}

//获取征稿活动列表
export function listPictureActivity(params) {
    return request({
        url: '/open/listPictureActivity',
        method: 'get',
        params
    })
}

//短信验证码
export function smsVerificationCode(params) {
    return request({
        url: '/open/smsVerificationCode',
        method: 'post',
        params
    })
}

//重置密码（通过验证码）
export function resetPassword(params) {
    return request({
        url: '/open/resetPassword',
        method: 'post',
        params
    })
}


//获取客户端最新版本
export function getDesktopVersion() {
    return request({
        url: '/open/getDesktopVersion',
        method: 'get'
    })
}

//获取微信临时票据（Ticket）
export function getWeixinTicket() {
    return request({
        url: '/open/getWeixinTicket',
        method: 'get'
    })
}

//获取网站栏目列表
export function listWebsiteColumn(params) {
    return request({
        url: '/open/website/listWebsiteColumn',
        method: 'get',
        params
    })
}

//获取微信
export function scan(params) {
    return request({
        url: '/open/scan',
        method: 'get',
        params
    })
}



//微信绑定手机号
export function bind(params) {
    return request({
        url: '/open/bind',
        method: 'get',
        params
    })
}